export function isMobile(): boolean {
  const { userAgent }: Navigator = navigator;
  if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(userAgent)) {
    return !(/ipad/i.test(userAgent) || /tablet/i.test(userAgent));
  }
  return false;
}

export function isAppleMobileDevice(): boolean {
  const { userAgent }: Navigator = navigator;
  return Boolean(userAgent.match(/iPad/i)) || isAppleIPhoneDevice();
}

export function isAppleIPhoneDevice(): boolean {
  const { userAgent }: Navigator = navigator;
  return Boolean(userAgent.match(/iPhone/i));
}

export function isIOSafari(): boolean {
  const { userAgent }: Navigator = navigator;
  return (
    isAppleMobileDevice() &&
    !userAgent.match(/crios/i) &&
    !userAgent.match(/fxios/i) &&
    !userAgent.match(/EdgiOS/i) &&
    !userAgent.match(/Opera|OPT\//)
  );
}

export function isIOSIphoneSafariSingleTab(): boolean {
  const singleTab: number = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue('--safe-area-inset-bottom')
  );
  return isIOSafari() && singleTab > 0;
}
